import React from "react";

import { TimeSeries } from "../../../common/src";
import { TimeSeriesLines } from "../charts/TimeSeriesLines";
import { ChartLayout, formatterFromTickformat, layoutHeight, layoutWidth, seriesFromTimeSeries } from "../charts/chartTheme";

interface IRelativePerformanceTimeSeriesChartProps {
    value: any;
    style?: React.CSSProperties | undefined;
    layout?: ChartLayout;
}

export const RelativePerformanceTimeSeriesChart = ({ value, layout, style }: IRelativePerformanceTimeSeriesChartProps): React.ReactElement => {
    const portf = value;
    let pm = portf.returnTimeSeries;
    let bm = portf.benchmarkTimeSeries;
    let max = 0.05;
    let diff: TimeSeries = null;
    if (portf.benchmarkTimeSeries && portf.benchmarkTimeSeries.length > 0) {
        const start = pm.start.number > bm.start.number ? pm.start : bm.start;
        const end = pm.end.number < bm.end.number ? pm.end : bm.end;
        pm = pm.range(start, end);
        pm = pm.mult(1 / pm.startValue);
        bm = TimeSeries.align(pm, bm);
        bm = bm.mult(1 / bm.startValue);
        diff = TimeSeries.weightedTimeSeries([1.0, -1.0], [pm, bm]);
        max = diff.__values.reduce((previous, current) => Math.max(Math.abs(current), previous), 0);
    }
    const series = diff ? [seriesFromTimeSeries(diff, "rgba(67, 160, 76, 1.0)")] : [];
    if (series[0]) {
        series[0].fill = true;
        series[0].name = portf.name || "Relative";
    }

    return (
        <TimeSeriesLines
            series={series}
            yFormat={formatterFromTickformat(max < 0.06 ? ".1%" : ".0%")}
            showLegend={false}
            ariaLabel="Relative performance"
            height={layoutHeight(layout, 320)}
            width={layoutWidth(layout)}
            style={style}
        />
    );
};
